module.exports = __webpack_public_path__ + "img/election_results_imported.83a3a874.png";